export interface BatchOrderAcceptListRequest {
  orderDateFrom: string
  orderDateTo: string
  rdoOrderType: string
  acceptType: string
  orderBranch: string
  orderCollectionType: string
  isCollectionPeriod: boolean
  rdoOrderListOrder: string
  rdoSituationListOutput: string
  ndcDigits: string
  rdoAmountDispType: string
  rdoOutputConditionType: string
  traderType: string
  donorType: string
  budgetDepType: string
  acceptanceSearchBooks: boolean
  acceptanceSearchAV: boolean
  acceptanceSearchMagazine: boolean
  rdoAutoOrderType: string
  orderNumFrom: string
  orderNumTo: string
  isTargetAlreadyOrder: boolean
  isTargetNotOrder: boolean
  batchType: string
}

export function BatchOrderAcceptListRequestToJSON(
  value: BatchOrderAcceptListRequest
): any {
  return {
    order_date_from: value.orderDateFrom,
    order_date_to: value.orderDateTo,
    rdo_order_type: value.rdoOrderType,
    accept_type: value.acceptType,
    order_branch: value.orderBranch,
    order_collection_type: value.orderCollectionType,
    is_collection_pediod: value.isCollectionPeriod,
    rdo_order_list_order: value.rdoOrderListOrder,
    rdo_situation_list_output: value.rdoSituationListOutput,
    ndc_digits: value.ndcDigits,
    rdo_amount_disp_type: value.rdoAmountDispType,
    rdo_output_condition_type: value.rdoOutputConditionType,
    trader_type: value.traderType,
    donor_type: value.donorType,
    budget_dep_type: value.budgetDepType,
    acceptance_search_books: value.acceptanceSearchBooks,
    acceptance_search_av: value.acceptanceSearchAV,
    acceptance_search_magazine: value.acceptanceSearchMagazine,
    rdo_auto_order_type: value.rdoAutoOrderType,
    order_num_from: value.orderNumFrom,
    order_num_to: value.orderNumTo,
    is_target_already_order: value.isTargetAlreadyOrder,
    is_target_not_order: value.isTargetNotOrder,
    batch_type: value.batchType
  }
}
